var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Anim',{attrs:{"width":800,"height":800,"name":"teamfilm"}}),_c('Anim',{attrs:{"width":800,"height":800,"name":"check","opacity":0.5}}),_c('Anim',{attrs:{"width":200,"height":200,"name":"fail","opacity":0.5}}),_c('Anim',{attrs:{"width":400,"height":400,"name":"delete","opacity":0.9}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }